import { isEmptyObject, isNumeric } from "../../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const formValidator = (values) => 
{   
    let formErrors = {};
    
    let title = values["Title"];
    let importance = values["Importance"];
    let isAggregate = values["IsAggregate"];
    let isVariant = values["IsVariant"];
    let aggregateExpressionId = values["AggregateExpressionId"];
    let aggregateFunctionId = values["AggregateFunctionId"];
    let fieldId = values["FieldId"];
    let operatorId = values["OperatorId"];
    let targetValueMin = values["TargetValueMin"];
    let targetValueMax = values["TargetValueMax"];
    let timeFieldId = values["TimeFieldId"];
    let recurrsEvery = values["RecurrsEvery"];
    let coveredPeriod = values["CoveredPeriod"];
    let variantCoveredPeriod = values["VariantCoveredPeriod"];
    let isSystem = values["IsSystem"];
    
    const t = i18next.t.bind(i18next);

    if (!title || title.trim().length == 0)
        formErrors = Object.assign(formErrors, {Title: t("alerts.error")});
    else if (!isSystem && title.trim().indexOf("©") >= 0)
        formErrors = Object.assign(formErrors, {Title: t("alerts.error1")});

    if (isAggregate)
    {
        if (aggregateExpressionId == null)
            formErrors = Object.assign(formErrors, {AggregateExpressionId: t("alerts.agg_error")});
        
        if (aggregateFunctionId > 0)
            formErrors = Object.assign(formErrors, {AggregateFunctionId: t("alerts.agg_error1")});
        
        if (fieldId != null)
            formErrors = Object.assign(formErrors, {FieldId: t("alerts.field_error")});
    } 
    else
    {
        if (aggregateExpressionId != null)
            formErrors = Object.assign(formErrors, {AggregateExpressionId: t("alerts.exp_error")});

        if (aggregateFunctionId <= 0)
            formErrors = Object.assign(formErrors, {AggregateFunctionId: t("alerts.fct_error")});
    
        if (fieldId == null)
            formErrors = Object.assign(formErrors, {FieldId: t("alerts.field_error1")});
    }

    if (operatorId < 1)
        formErrors = Object.assign(formErrors, {OperatorId: t("alerts.op_error")});

        
    if (operatorId == 7 || operatorId == 8)
    {
        if (targetValueMin === null || targetValueMin === undefined || targetValueMin.toString().trim() == "")
            formErrors = Object.assign(formErrors, {TargetValueMin: t("alerts.minimum")});
        else if (!isNumeric(targetValueMin.toString()))
            formErrors = Object.assign(formErrors, {TargetValueMin: t("alerts.minimum1")});

        if (targetValueMax === null || targetValueMax === undefined || targetValueMax.toString().trim() == "")
            formErrors = Object.assign(formErrors, {TargetValueMax: t("alerts.maximum")});
        else if (!isNumeric(targetValueMax.toString()))
            formErrors = Object.assign(formErrors, {TargetValueMax: t("alerts.maximum1")});

        if (isNumeric(targetValueMin.toString()) && isNumeric(targetValueMax.toString()) && parseFloat(targetValueMin) > parseFloat(targetValueMax))
            formErrors = Object.assign(formErrors, {TargetValueMin: t("alerts.minimum2")});
    }
    else
    {
        if (targetValueMin !== 0 && targetValueMin !== "0")
        {
            if (targetValueMin === null || targetValueMin === undefined || targetValueMin.toString().trim() == "")
                formErrors = Object.assign(formErrors, {TargetValueMin: t("alerts.threshold1")});
            else if (!isNumeric(targetValueMin.toString()))
                formErrors = Object.assign(formErrors, {TargetValueMin: t("alerts.threshold2")});
        }
    }

    if (importance == 0)
        formErrors = Object.assign(formErrors, {Importance: t("alerts.importance1")});

    if (timeFieldId == 0)
        formErrors = Object.assign(formErrors, {TimeFieldId: t("alerts.timefield1")});

    if (recurrsEvery == 0)
        formErrors = Object.assign(formErrors, {RecurrsEvery: t("alerts.recurs1")});

    if (coveredPeriod == 0)
        formErrors = Object.assign(formErrors, {CoveredPeriod: t("alerts.covered1")});
        
    if (isVariant && variantCoveredPeriod == 0)
        formErrors = Object.assign(formErrors, {VariantCoveredPeriod: t("alerts.period1")});

    

    if (isEmptyObject(formErrors))
       return undefined;
    
    return formErrors;        
}